import React, { useState, useContext, useEffect } from "react";
import { Table, Button } from "reactstrap";
import { FileMinus } from "lucide-react";
import { AppContext } from '../application/provider';
import Loader from "../components/Loader/Loader";
import { ButtonSearch } from '../components/Buttons/Buttons';
import ButtonPdf from '../components/Buttons/ButtonPdf';
import ButtonExcel from '../components/Buttons/ButtonExcel';
import ButtonInsert from '../components/Buttons/ButtonInsert';
import ButtonUpdate from '../components/Buttons/ButtonUpdate';
import ModalRegistroPracticante from '../components/Modal/ModalRegistroPracticante';
import ModalEstadoPagoPracticante from '../components/Modal/ModalEstadoPagoPracticante';
import ModalValidacionPracticantes from '../components/Modal/ModalValidacionPracticantes';
import "./CargoPago.css";

import RhPracticantesService from "../axios_services/rh_practicantes.service";
import ArchivosService from "../axios_services/archivos.service";

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

const getEmptyRow = () => ({
    rh_practicantes_id: null, apellidos_nombre: '', 
    fecha_ingreso: '', total_pagar: 0, importe_neto_pagar: 0, 
    dni: '', n_cuenta: '', n_cuenta_interbancaria: '', entidad_bancaria: '', 
    estado_practicante: 'ACTIVO', fecha_cese: '', fecha_pago: '', boleta_url: null
});

function RhPracticantes() {
    const [state] = useContext(AppContext);
    const userId = Number(state.user?.perfil_id);
    const [periodo_fecha, setPeriodoFecha] = useState(() => {
        const now = new Date();
        return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
    });
    const [areaFiltro, setAreaFiltro] = useState(userId === 1 ? 2 : 1);
    const [areaAplicada, setAreaAplicada] = useState(userId === 1 ? 2 : 1);

    const [loading, setLoading] = useState(true);
    const [planillaData, setPlanillaData] = useState([]);
    const [validationStatus, setValidationStatus] = useState(null);

    const [registroModal, setRegistroModal] = useState(false);
    const [estadoPagoModal, setEstadoPagoModal] = useState(false);
    const [validacionModal, setValidacionModal] = useState(false);
    const [selectedItemEdit, setSelectedItemEdit] = useState(null);
    const [selectedItemPago, setSelectedItemPago] = useState(null);
    const tipo_pagos = state.catalogos?.tipos?.filter(t => t.categoria_id == 32) || [];
    const entidades_bancarias = state.catalogos?.tipos?.filter(t => t.categoria_id == 25) || [];

    const getBankName = (id) => {
        if (!id) return '';
        const bank = entidades_bancarias.find(b => String(b.tipo_id) === String(id));
        return bank ? bank.descripcion.toUpperCase() : id;
    };

    const fetchDatos = async () => {
        setLoading(true);
        try {
            const dbPlanilla = await RhPracticantesService.getPlanilla(periodo_fecha, areaFiltro).catch(() => []);
            const arrDbPlanilla = Array.isArray(dbPlanilla) ? dbPlanilla : (dbPlanilla?.data || Object.values(dbPlanilla || {}) || []);

            const boletasData = await ArchivosService.getBoletasPagoPeriodo(periodo_fecha).catch(() => []);
            const arrBoletas = Array.isArray(boletasData) ? boletasData : (boletasData?.data || []);

            const comprobantesData = await ArchivosService.getComprobantesPagoPeriodo(periodo_fecha).catch(() => []);
            const arrComprobantes = Array.isArray(comprobantesData) ? comprobantesData : (comprobantesData?.data || []);

            const validationRow = arrDbPlanilla[0];
            const isThAprob = validationRow ? Number(validationRow.aprobado_th || 0) : 0;
            const isSaAprob = validationRow ? Number(validationRow.aprobado_sa || 0) : 0;
            const isGgAprob = validationRow ? Number(validationRow.aprobado_gg || 0) : 0;
            const currentValId = validationRow ? Number(validationRow.validacion_id || 0) : 0;

            const nombreTh = validationRow ? validationRow.nombre_th : null;
            const nombreSa = validationRow ? validationRow.nombre_sa : null;
            const nombreGg = validationRow ? validationRow.nombre_gg : null;

            const computedData = arrDbPlanilla.map((dbRow) => {
                const rowData = {
                    ...dbRow,
                    apellidos_nombre: dbRow.apellidos_nombre || '',
                    fecha_ingreso: dbRow.fecha_ingreso || '',
                    total_pagar: parseFloat(dbRow.total_pagar || 0),
                    importe_neto_pagar: parseFloat(dbRow.importe_neto_pagar || 0),
                    dni: dbRow.dni || '',
                    n_cuenta: dbRow.n_cuenta || '',
                    n_cuenta_interbancaria: dbRow.n_cuenta_interbancaria || '',
                    entidad_bancaria: dbRow.entidad_bancaria || '',
                    estado_practicante: dbRow.estado_practicante || '',
                    fecha_cese: dbRow.fecha_cese || '',
                    fecha_pago: dbRow.fecha_pago || ''
                };

                const boleta = arrBoletas.find(b => 
                    (Number(b.origen_id) === Number(dbRow.rh_practicantes_id)) || 
                    (Number(b.usuario_id) === Number(dbRow.rh_practicantes_id))
                );
                rowData.boleta_url = boleta ? boleta.url_completa : null;
                
                const comprobante = arrComprobantes.find(b => 
                    (Number(b.origen_id) === Number(dbRow.rh_practicantes_id)) || 
                    (Number(b.usuario_id) === Number(dbRow.rh_practicantes_id))
                );
                rowData.comprobante_url = comprobante ? comprobante.url_completa : null;

                rowData.fecha_pago_db = rowData.fecha_pago;

                return rowData;
            });

            setPlanillaData(computedData);
            setAreaAplicada(areaFiltro);
            if (computedData.length > 0) {
                setValidationStatus({
                    aprobado_th: isThAprob,
                    aprobado_sa: isSaAprob,
                    aprobado_gg: isGgAprob,
                    validacion_id: currentValId,
                    nombre_th: nombreTh,
                    nombre_sa: nombreSa,
                    nombre_gg: nombreGg
                });
            } else {
                setValidationStatus(null);
            }

        } catch (error) {
            console.error('Error fetching data:', error);
            setPlanillaData([]);
            setValidationStatus(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDatos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearch = () => {
        fetchDatos();
    };

    const handleAddRow = () => {
        setSelectedItemEdit(null);
        setRegistroModal(true);
    };

    const handleEditRow = (row) => {
        setSelectedItemEdit(row);
        setRegistroModal(true);
    };

    const onSaveRegistro = async (formData, boletaFile) => {
        setLoading(true);
        try {
            await RhPracticantesService.guardarPlanilla(periodo_fecha, areaFiltro, formData);
            
            // To save the boleta, we might need the ID. If it's a new row, we have to fetch again or alert user.
            // Since `guardarPlanilla` is a mass save or creates one, it doesn't return the ID explicitly.
            // But we can check if formData.rh_practicantes_id exists.
            if (boletaFile && formData.rh_practicantes_id) {
                await ArchivosService.guardarBoletaPago(boletaFile, formData.rh_practicantes_id, periodo_fecha, state.user.usuario_id);
            } else if (boletaFile) {
                alert('Registro guardado. Por favor, vuelve a abrir el registro para subir la boleta, ya que ahora cuenta con un ID generado.');
            }

            alert("Registro y boleta guardados correctamente.");
            setRegistroModal(false);
            fetchDatos();
        } catch (error) {
            alert("Error al guardar: " + (error.response?.data?.error || error.message));
        } finally {
            setLoading(false);
        }
    };

    const handleAprobar = () => {
        setValidacionModal(true);
    };

    const formatSoles = (val) => new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(val || 0);
    
    
    const totalImporteNeto = planillaData.reduce((sum, row) => sum + (Number(row.importe_neto_pagar) || 0), 0);

    const getStatusText = () => {
        if (!validationStatus) return "PENDIENTE";
        const { validacion_id } = validationStatus;
        if (validacion_id === 5) return "VALIDADO POR GERENCIA GENERAL";
        if (validacion_id === 4) return "VALIDADO POR SUBGERENCIA ADMINISTRATIVA";
        if (validacion_id === 3) return "VALIDADO POR GERENCIA DE NEGOCIOS";
        if (validacion_id === 2) return "VALIDADO POR TALENTO HUMANO";
        if (validacion_id === 6) return "OBSERVADO / RECHAZADO";
        return "PENDIENTE";
    };

    const isApprovalDisabled = () => {
        if (!state.user || planillaData.length === 0) return true;
        const perfil = Number(state.user.perfil_id);
        const valId = validationStatus ? Number(validationStatus.validacion_id) : 0;
        const area = Number(areaFiltro);

        /*
        // =========================================================================
        // CODIGO ANTERIOR CON PERFIL 5 (TALENTO HUMANO) COMO PRIMER PASO OBLIGATORIO:
        // Descomentar cuando el perfil 5 vuelva a operar independientemente:
        // =========================================================================
        // // TH o Admin: habilitado si está en 0 o 6 (Rechazado)
        // if ([5, 8].includes(perfil)) return ![0, 6].includes(valId);
        // // Gerencia Negocios (1): solo si el área es NEGOCIOS (2) y TH ya validó (2)
        // if (perfil === 1) return area !== 2 || valId !== 2;
        // // Subgerencia (26): solo si el área es ADMIN (1) o GERENCIA (4) y TH ya validó (2)
        // if (perfil === 26) return ![1, 4].includes(area) || valId !== 2;
        // // Gerencia General (9): habilitado si GN (3) o SA (4) ya validaron
        // if (perfil === 9) return ![3, 4].includes(valId);
        // =========================================================================
        */

        // TH o Admin (5, 8): habilitado si está en 0 o 6 (Rechazado)
        if ([5, 8].includes(perfil)) return ![0, 6].includes(valId);
        
        // Gerencia Negocios (1): si el área es NEGOCIOS (2) y está en 0, 6 o 2
        if (perfil === 1) return area !== 2 || ![0, 6, 2].includes(valId);
        
        // Subgerencia (26): administra y puede validar directamente si está en pendiente (0, 6) o tras TH (2)
        if (perfil === 26) return valId === 4 || valId === 5;
        
        // Gerencia General (9): habilitado si ya fue validado por SA (4), GN (3) o TH/Admin (2)
        if (perfil === 9) return ![2, 3, 4].includes(valId) || valId === 5;
        
        return true;
    };

    const isExportEnabled = validationStatus && validationStatus.validacion_id >= 2 && validationStatus.validacion_id !== 6;

    const exportToPDF = async () => {
        const doc = new jsPDF('landscape', 'pt', 'a4');
        const getMonthName = (YYYY_MM) => {
            if (!YYYY_MM) return '';
            const [y, m] = YYYY_MM.split('-');
            const date = new Date(Number(y), Number(m) - 1, 1);
            return date.toLocaleString('es-PE', { month: 'long', year: 'numeric' }).toUpperCase();
        };
        const monthYearStr = getMonthName(periodo_fecha);
        const areaName = areaAplicada === 1 ? 'ADMINISTRACIÓN' : (areaAplicada === 2 ? 'NEGOCIOS' : 'GERENCIA');

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text("MEC BUSINNES PARTNER S.A.C.", 28, 30);
        doc.text("20612796484", 28, 45);

        const tableColumnNames = areaAplicada === 2 ? [
            "N°", "APELLIDOS Y NOMBRE", "FECHA DE INGRESO", "PAGO POR PRODUCCION",
            "MONTO REGULARIZAR", "DESC. EXTRA", "DESC. CANCELADO", "DESC. DOC. OBSERV.", "RETENCIÓN",
            { content: "IMPORTE NETO A PAGAR", styles: { fillColor: [255, 255, 0], textColor: [0, 0, 0] } },
            "N° DNI", "N° CUENTA", "N° CUENTA INTERBANCARIA", "ENTIDAD BANCARIA", "ESTADO", "FECHA DE CESE",
            { content: "FECHA DE PAGO", styles: { fillColor: [225, 213, 231], textColor: [0, 0, 0] } }
        ] : [
            "N°", "APELLIDOS Y NOMBRE", "FECHA DE INGRESO", "TOTAL A PAGAR",
            { content: "IMPORTE NETO A PAGAR", styles: { fillColor: [255, 255, 0], textColor: [0, 0, 0] } },
            "N° DNI", "N° CUENTA", "N° CUENTA INTERBANCARIA", "ENTIDAD BANCARIA", "ESTADO", "FECHA DE CESE",
            { content: "FECHA DE PAGO", styles: { fillColor: [225, 213, 231], textColor: [0, 0, 0] } }
        ];

        const formatNumber = (val) => {
            if (val === 0 || !val) return "S/ -";
            return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN', minimumFractionDigits: 2 }).format(val);
        };

        const tableRows = planillaData.map((row, index) => {
            if (areaAplicada === 2) {
                return [
                    index + 1,
                    row.apellidos_nombre?.toUpperCase(),
                    row.fecha_ingreso || '',
                    formatNumber(row.total_pagar),
                    formatNumber(row.monto_regularizar),
                    formatNumber(row.desc_extra),
                    formatNumber(row.desc_cancelado),
                    formatNumber(row.desc_documento_observado),
                    formatNumber(row.retencion),
                    { content: formatNumber(row.importe_neto_pagar), styles: { fillColor: [255, 255, 204], textColor: [0, 0, 0], fontStyle: 'bold' } },
                    row.dni,
                    row.n_cuenta,
                    row.n_cuenta_interbancaria,
                    row.entidad_bancaria?.toUpperCase(),
                    row.estado_practicante?.toUpperCase(),
                    row.fecha_cese || '',
                    row.fecha_pago || ''
                ];
            } else {
                return [
                    index + 1,
                    row.apellidos_nombre?.toUpperCase(),
                    row.fecha_ingreso || '',
                    formatNumber(row.total_pagar),
                    { content: formatNumber(row.importe_neto_pagar), styles: { fillColor: [255, 255, 204], textColor: [0, 0, 0], fontStyle: 'bold' } },
                    row.dni,
                    row.n_cuenta,
                    row.n_cuenta_interbancaria,
                    row.entidad_bancaria?.toUpperCase(),
                    row.estado_practicante?.toUpperCase(),
                    row.fecha_cese || '',
                    row.fecha_pago || ''
                ];
            }
        });

        const totalColCount = areaAplicada === 2 ? 17 : 12;
        const totalNetoIndex = areaAplicada === 2 ? 9 : 4;
        const totalRow = Array(totalColCount).fill("");
        totalRow[totalNetoIndex] = formatNumber(totalImporteNeto);
        tableRows.push(totalRow);

        autoTable(doc, {
            startY: 60,
            head: [
                [{
                    content: `PLANILLA PRACTICANTES DE ${monthYearStr} - ${areaName}`,
                    colSpan: totalColCount,
                    styles: { halign: 'center', fillColor: [255, 192, 0], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 9, lineColor: [0, 0, 0], lineWidth: 0.5 }
                }],
                tableColumnNames
            ],
            body: tableRows,
            theme: 'grid',
            styles: { fontSize: 6, cellPadding: 2, overflow: 'linebreak', halign: 'center', valign: 'middle', lineColor: [0, 0, 0], lineWidth: 0.5 },
            margin: { left: 20, right: 20 },
            headStyles: { fillColor: [220, 220, 220], textColor: [0, 0, 0], fontStyle: 'bold', fontSize: 6, lineColor: [0, 0, 0], lineWidth: 0.5 },
            columnStyles: {
                1: { halign: 'left', cellWidth: 150 },
            },
            didParseCell: function (data) {
                if (data.section === 'body' && data.row.index === tableRows.length - 1) {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.fillColor = [255, 255, 255];
                }
            }
        });

        const finalY = doc.lastAutoTable ? doc.lastAutoTable.finalY : 100;
        let startY = finalY + 110;
        if (startY > doc.internal.pageSize.height - 70) { doc.addPage(); startY = 70; }

        try {
            /*
            // =========================================================================
            // CODIGO ANTERIOR (3 FIRMAS CON TALENTO HUMANO / PERFIL 5 INDEPENDIENTE)
            // Reactivar cuando vuelva el perfil 5 con firma propia:
            // =========================================================================
            // const [firmaThRes, firmaGgRes, firmaSaRes] = await Promise.all([
            //     validationStatus?.aprobado_th ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_th).catch(() => null) : null,
            //     validationStatus?.aprobado_gg ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_gg).catch(() => null) : null,
            //     validationStatus?.aprobado_sa ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_sa).catch(() => null) : null
            // ]);
            // const firmaThB64 = firmaThRes?.base64 || null;
            // const firmaGgB64 = firmaGgRes?.base64 || null;
            // const firmaSaB64 = firmaSaRes?.base64 || null;
            // const pageWidth = doc.internal.pageSize.width;
            // const center1 = pageWidth * 0.25; const center2 = pageWidth * 0.50; const center3 = pageWidth * 0.75;
            // doc.setFontSize(7);
            // drawSignature(firmaGgB64, validationStatus?.nombre_gg?.toUpperCase() || "", "GERENTE GENERAL", center1, startY);
            // drawSignature(firmaSaB64, validationStatus?.nombre_sa?.toUpperCase() || "", "SUB GERENTE DE ADMINISTRACIÓN", center2, startY);
            // drawSignature(firmaThB64, validationStatus?.nombre_th?.toUpperCase() || "", "JEFE DE TALENTO HUMANO", center3, startY);
            // =========================================================================
            */

            // CONFIGURACIÓN ACTUAL (ADMINISTRADO POR PERFIL 26 - EVITA FIRMA DUPLICADA)
            const tieneThDistinto = validationStatus?.aprobado_th && 
                                    validationStatus?.aprobado_th !== validationStatus?.aprobado_sa &&
                                    validationStatus?.nombre_th &&
                                    validationStatus?.nombre_th !== validationStatus?.nombre_sa;

            const [firmaThRes, firmaGgRes, firmaSaRes] = await Promise.all([
                tieneThDistinto ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_th).catch(() => null) : null,
                validationStatus?.aprobado_gg ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_gg).catch(() => null) : null,
                (validationStatus?.aprobado_sa || validationStatus?.aprobado_th) ? ArchivosService.getFirmaDigitalConvenio(validationStatus.aprobado_sa || validationStatus.aprobado_th).catch(() => null) : null
            ]);
            const firmaThB64 = firmaThRes?.base64 || null;
            const firmaGgB64 = firmaGgRes?.base64 || null;
            const firmaSaB64 = firmaSaRes?.base64 || null;
            const pageWidth = doc.internal.pageSize.width;

            doc.setFontSize(7);
            const drawSignature = (b64, name, role, cx, y) => {
                if (b64) {
                    const format = b64.includes('image/jpeg') || b64.includes('image/jpg') || b64.includes('data:image/jpeg') ? 'JPEG' : 'PNG';
                    doc.addImage(b64, format, cx - 50, y - 50, 100, 50);
                }
                doc.setLineWidth(0.5);
                doc.line(cx - 75, y, cx + 75, y);
                doc.setFont("helvetica", "bold"); doc.text(role, cx, y + 12, { align: 'center' });
                if (name) { doc.setFont("helvetica", "normal"); doc.text(name, cx, y + 22, { align: 'center' }); }
            };

            if (tieneThDistinto) {
                const center1 = pageWidth * 0.25; const center2 = pageWidth * 0.50; const center3 = pageWidth * 0.75;
                drawSignature(firmaGgB64, validationStatus?.nombre_gg?.toUpperCase() || "", "GERENTE GENERAL", center1, startY);
                drawSignature(firmaSaB64, validationStatus?.nombre_sa?.toUpperCase() || "", "SUB GERENTE DE ADMINISTRACIÓN", center2, startY);
                drawSignature(firmaThB64, validationStatus?.nombre_th?.toUpperCase() || "", "JEFE DE TALENTO HUMANO", center3, startY);
            } else {
                const center1 = pageWidth * 0.35; const center2 = pageWidth * 0.65;
                const nombreSa = (validationStatus?.nombre_sa || validationStatus?.nombre_th || "").toUpperCase();
                drawSignature(firmaSaB64, nombreSa, "SUB GERENTE DE ADMINISTRACIÓN", center1, startY);
                drawSignature(firmaGgB64, validationStatus?.nombre_gg?.toUpperCase() || "", "GERENTE GENERAL", center2, startY);
            }
        } catch (e) { } 

        doc.save(`planilla_practicantes_${areaName}_${periodo_fecha.replace('-', '_')}.pdf`);
    };

    const exportToExcel = async () => {
        const getMonthName = (YYYY_MM) => {
            if (!YYYY_MM) return '';
            const [y, m] = YYYY_MM.split('-');
            const date = new Date(Number(y), Number(m) - 1, 1);
            return date.toLocaleString('es-PE', { month: 'long', year: 'numeric' }).toUpperCase();
        };
        const monthYearStr = getMonthName(periodo_fecha);
        const areaName = areaAplicada === 1 ? 'ADMINISTRACIÓN' : (areaAplicada === 2 ? 'NEGOCIOS' : 'GERENCIA');

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Planilla Practicantes');

        worksheet.getRow(1).values = ['MEC BUSINNES PARTNER S.A.C.'];
        worksheet.getRow(2).values = ['20612796484'];
        worksheet.mergeCells('A4:L4');
        worksheet.getCell('A4').value = `PLANILLA PRACTICANTES DE ${monthYearStr} - ${areaName}`;
        worksheet.getCell('A4').alignment = { horizontal: 'center' };

        const headers = areaAplicada === 2 ? [
            "N°", "APELLIDOS Y NOMBRE", "FECHA DE INGRESO", "PAGO POR PRODUCCION",
            "MONTO REGULARIZAR", "DESC. EXTRA", "DESC. CANCELADO", "DESC. DOC. OBSERV.", "RETENCIÓN",
            "IMPORTE NETO A PAGAR", "N° DNI", "N° CUENTA", "N° CUENTA INTERBANCARIA", "ENTIDAD BANCARIA", "ESTADO", "FECHA DE CESE", "FECHA DE PAGO"
        ] : [
            "N°", "APELLIDOS Y NOMBRE", "FECHA DE INGRESO", "TOTAL A PAGAR", "IMPORTE NETO A PAGAR",
            "N° DNI", "N° CUENTA", "N° CUENTA INTERBANCARIA", "ENTIDAD BANCARIA", "ESTADO", "FECHA DE CESE", "FECHA DE PAGO"
        ];
        worksheet.getRow(5).values = headers;
        worksheet.getRow(5).font = { bold: true };

        planillaData.forEach((row, index) => {
            if (areaAplicada === 2) {
                worksheet.addRow([
                    index + 1, row.apellidos_nombre, row.fecha_ingreso, row.total_pagar,
                    row.monto_regularizar, row.desc_extra, row.desc_cancelado, row.desc_documento_observado, row.retencion,
                    row.importe_neto_pagar, row.dni, row.n_cuenta, row.n_cuenta_interbancaria, getBankName(row.entidad_bancaria), row.estado_practicante, row.fecha_cese, row.fecha_pago
                ]);
            } else {
                worksheet.addRow([
                    index + 1, row.apellidos_nombre, row.fecha_ingreso, row.total_pagar, row.importe_neto_pagar,
                    row.dni, row.n_cuenta, row.n_cuenta_interbancaria, getBankName(row.entidad_bancaria), row.estado_practicante, row.fecha_cese, row.fecha_pago
                ]);
            }
        });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `Planilla_Practicantes_${areaName}_${periodo_fecha}.xlsx`);
    };

    const showBtnRegistro = [5, 8, 22].includes(userId);
    const showBtnEstado = [8, 21, 12, 26].includes(userId);

    const getRowClass = (it) => {
        if (!it.rh_practicantes_id) return '';
        const { validacion_id } = validationStatus || { validacion_id: 0 };
        if (validacion_id === 6) return 'row-rechazado';
        if (validacion_id >= 2) return 'row-validado';
        return 'row-registrado';
    };

    return (
        <div className="cargo-pago-module">
            {loading && <Loader />}
            <div className="flex items-center justify-between mb-4">
                <h1>PLANILLA PRACTICANTES</h1>
                <div className="flex gap-2">
                    <ButtonPdf onClick={exportToPDF} disabled={loading || planillaData.length === 0 || !isExportEnabled} />
                    <ButtonExcel onClick={exportToExcel} disabled={loading || planillaData.length === 0 || !isExportEnabled} />
                </div>
            </div>
            <div className="filtros flex gap-4">
                <div>
                    <label>Periodo de fecha:</label>
                    <input type="month" value={periodo_fecha} onChange={(e) => setPeriodoFecha(e.target.value)} />
                </div>
                <div>
                    <label>Área:</label>
                    <select 
                        value={areaFiltro} 
                        onChange={(e) => setAreaFiltro(Number(e.target.value))}
                        disabled={userId === 1}
                    >
                        {userId !== 1 && <option value={1}>ADMINISTRACION</option>}
                        <option value={2}>NEGOCIOS</option>
                        {userId !== 1 && <option value={4}>GERENCIA</option>}
                    </select>
                </div>
            </div>
            <div className="flex flex-col gap-4 mb-4">
                <div className="flex flex-col gap-3">
                    <div className="w-full">
                        <ButtonSearch onClick={handleSearch} isLoading={loading} />
                    </div>
                    <div className="flex justify-between items-center w-full">
                        <div className="flex items-center gap-4">
                            {planillaData.length > 0 && (
                                <div style={{
                                    backgroundColor: '#f5f5f5',
                                    padding: '10px 20px',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    border: '1px solid #e0e0e0'
                                }}>
                                    <span className="text-sm text-gray-700 uppercase tracking-wider" style={{ fontWeight: '400' }}>
                                        {getStatusText()}
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="flex items-center gap-3">
                            <Button
                                className={`px-4 py-2 rounded-lg text-xs font-semibold ${isApprovalDisabled() ? "bg-[#0b4d17] opacity-95 cursor-not-allowed" : "bg-green-600 hover:bg-green-700"} text-white border-none`}
                                onClick={handleAprobar}
                                disabled={isApprovalDisabled()}
                            >
                                {userId === 11 ? "Enviar" : "Aprobar"}
                            </Button>
                            {[5, 22, 8].includes(userId) && (
                                <ButtonInsert onClick={handleAddRow} />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <ModalRegistroPracticante
                isOpen={registroModal}
                toggle={() => {
                    setRegistroModal(false);
                    setSelectedItemEdit(null);
                }}
                onSave={onSaveRegistro}
                selectedItem={selectedItemEdit}
                area_id={areaAplicada}
            />
            <ModalEstadoPagoPracticante
                isOpen={estadoPagoModal}
                onClose={() => { setEstadoPagoModal(false); setSelectedItemPago(null); }}
                onRefresh={fetchDatos}
                item={selectedItemPago}
                periodo={periodo_fecha}
            />
            <ModalValidacionPracticantes 
                isOpen={validacionModal} 
                onClose={() => setValidacionModal(false)} 
                onRefresh={fetchDatos} 
                data={planillaData}
                periodo={periodo_fecha}
                areaId={areaAplicada}
            />

            <div className="table-container shadow-sm overflow-x-auto">
                <Table bordered hover size="sm" className="text-[11px] m-0" style={{ minWidth: '1900px' }}>
                    <thead className="bg-[#14233a] text-white text-center align-middle">
                        <tr>
                            <th className="p-1" style={{ width: '40px' }}>N°</th>
                            <th className="p-1" style={{ minWidth: '280px' }}>APELLIDOS Y NOMBRE</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>FECHA DE INGRESO</th>
                            <th className="p-1" style={{ minWidth: '140px' }}>{areaAplicada === 2 ? 'PAGO POR PRODUCCION MES' : 'TOTAL A PAGAR'}</th>
                            {areaAplicada === 2 && (
                                <>
                                    <th className="p-1" style={{ minWidth: '175px' }}>MONTO A REGULARIZAR<br/>MESES ANTERIORES</th>
                                    <th className="p-1" style={{ minWidth: '120px' }}>DESC. EXTRA</th>
                                    <th className="p-1" style={{ minWidth: '120px' }}>DESC. CANCELADO</th>
                                    <th className="p-1" style={{ minWidth: '130px' }}>DESC. POR DOC. OBSERV.</th>
                                    <th className="p-1" style={{ minWidth: '120px' }}>RETENCIÓN</th>
                                </>
                            )}
                            <th className="p-1 bg-yellow-400 text-black" style={{ minWidth: '140px' }}>IMPORTE NETO<br />A PAGAR</th>
                            <th className="p-1" style={{ minWidth: '90px' }}>N° DNI</th>
                            <th className="p-1" style={{ minWidth: '160px' }}>N° CUENTA</th>
                            <th className="p-1" style={{ minWidth: '210px' }}>N° CUENTA INTERBANCARIA</th>
                            <th className="p-1" style={{ minWidth: '180px' }}>ENTIDAD BANCARIA</th>
                            <th className="p-1" style={{ minWidth: '110px' }}>ESTADO</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>FECHA DE CESE</th>
                            <th className="p-1" style={{ minWidth: '140px' }}>RECIBO POR<br />HONORARIOS</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>ESTADO PAGO</th>
                            <th className="p-1" style={{ minWidth: '120px' }}>FECHA PAGO</th>
                            <th className="p-1" style={{ minWidth: '140px' }}>COMPROBANTE<br />DE PAGO</th>
                            {(showBtnRegistro || showBtnEstado) && (
                                <th className="p-1 text-center" style={{ minWidth: '120px' }}>ACCIONES</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {planillaData.length > 0 ? planillaData.map((row, index) => {
                            return (
                            <tr key={index} className={`align-middle ${getRowClass(row)}`}>
                                <td className="text-center">{index + 1}</td>
                                <td className="px-1">{row.apellidos_nombre}</td>
                                <td className="text-center">{row.fecha_ingreso}</td>
                                <td className="text-center">{formatSoles(row.total_pagar)}</td>
                                {areaAplicada === 2 && (
                                    <>
                                        <td className="text-center font-semibold text-green-700">{formatSoles(row.monto_regularizar)}</td>
                                        <td className="text-center font-semibold text-red-600">{formatSoles(row.desc_extra)}</td>
                                        <td className="text-center font-semibold text-red-600">{formatSoles(row.desc_cancelado)}</td>
                                        <td className="text-center font-semibold text-red-600">{formatSoles(row.desc_documento_observado)}</td>
                                        <td className="text-center font-semibold text-red-600">{formatSoles(row.retencion)}</td>
                                    </>
                                )}
                                <td className="bg-yellow-100 font-bold text-center">{formatSoles(row.importe_neto_pagar)}</td>
                                <td className="text-center">{row.dni}</td>
                                <td className="text-center">{row.n_cuenta}</td>
                                <td className="text-center">{row.n_cuenta_interbancaria}</td>
                                <td className="text-center">{getBankName(row.entidad_bancaria)}</td>
                                <td className="text-center">{row.estado_practicante}</td>
                                <td className="text-center">{row.fecha_cese || '-'}</td>
                                <td className="text-center">
                                    <div className="flex justify-center items-center w-full">
                                        {row.boleta_url ? (
                                            <a href={row.boleta_url} target="_blank" rel="noreferrer" title="Ver Boleta de Pago">
                                                <FileMinus size={18} style={{ color: '#3cb167', cursor: 'pointer' }} />
                                            </a>
                                        ) : (
                                            <FileMinus size={18} style={{ color: '#f87171', opacity: 0.4, cursor: 'default' }} title="Sin boleta disponible" />
                                        )}
                                    </div>
                                </td>
                                <td className="text-center">
                                    {tipo_pagos.find(t => t.tipo_id === row.pago_id)?.descripcion || 'PENDIENTE'}
                                </td>
                                <td className="text-center">
                                    {row.fecha_pago || '—'}
                                </td>
                                <td className="text-center">
                                    <div className="flex justify-center items-center w-full">
                                        {row.comprobante_url ? (
                                            <a href={row.comprobante_url} target="_blank" rel="noreferrer" title="Ver Comprobante">
                                                <FileMinus size={18} style={{ color: '#3cb167', cursor: 'pointer' }} />
                                            </a>
                                        ) : (
                                            <FileMinus size={18} style={{ color: '#f87171', opacity: 0.4, cursor: 'default' }} title="Sin comprobante disponible" />
                                        )}
                                    </div>
                                </td>
                                {(showBtnRegistro || showBtnEstado) && (
                                    <td className="text-center">
                                        <div className="flex justify-center gap-1">
                                            {showBtnRegistro && (userId === 8 || [0, 6].includes(Number(row.validacion_id))) && (
                                                <ButtonUpdate onClick={() => handleEditRow(row)} title="Editar datos y Recibo" />
                                            )}
                                            {showBtnEstado && (userId === 8 || (Number(validationStatus?.validacion_id) >= 2 && Number(validationStatus?.validacion_id) !== 6)) && (
                                                <ButtonUpdate onClick={() => { setSelectedItemPago(row); setEstadoPagoModal(true); }} title="Actualizar Estado de Pago" />
                                            )}
                                        </div>
                                    </td>
                                )}
                            </tr>
                            );
                        }) : (
                            <tr><td colSpan={(showBtnRegistro || showBtnEstado) ? 17 : 16} className="text-center py-4 bg-white text-gray-400">No hay registros. Haga clic en Agregar para iniciar.</td></tr>
                        )}
                    </tbody>
                    <tfoot>
                        <tr className="font-bold border-t-2">
                            <td colSpan={areaAplicada === 2 ? 9 : 4} className="text-right p-1 border-0"></td>
                            <td className="bg-yellow-200 p-1 text-center">{formatSoles(totalImporteNeto)}</td>
                            <td colSpan={(showBtnRegistro || showBtnEstado) ? 12 : 11} className="p-1 border-0"></td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        </div>
    );
}

export default RhPracticantes;
